export const AUTOS = 'AUTOS';
export const HOGAR = 'HOGAR';
export const VIDA = 'VIDA';
export const SALUD = 'SALUD';
export const GASTOS_MEDICOS = 'GASTOS MEDICOS';
